<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>新一代信息技术专利</el-breadcrumb-item>
      <el-breadcrumb-item>专利管理</el-breadcrumb-item>
    </el-breadcrumb>


    <!-- 卡片视图 -->
    <el-card>
      <el-row :gutter="10">
        <el-col :span="3">
          <el-select v-model="queryParams.ptClass" placeholder="选择所属分类" @change="getDataList">
            <el-option-group label="下一代信息网络产业">
              <el-option label="计算机和辅助设备修理" value="301"></el-option>
              <el-option label="通信系统设备制造" value="302"></el-option>
              <el-option label="通信服务" value="303"></el-option>
              <el-option label="终端设备制造" value="304"></el-option>
              <el-option label="互联网服务" value="305"></el-option>
              <el-option label="其他" value="306"></el-option>
            </el-option-group>
            <el-option-group label="电子核心产业">
              <el-option label="电子材料" value="307"></el-option>
              <el-option label="电子测量仪器制造" value="308"></el-option>
              <el-option label="电子元件制造" value="309"></el-option>
              <el-option label="互联网安全服务" value="310"></el-option>
              <el-option label="半导体器件专用设备制造" value="311"></el-option>
              <el-option label="量子计算" value="312"></el-option>
              <el-option label="其他" value="313"></el-option>
            </el-option-group>
            <el-option-group label="新兴软件和新型信息技术服务">
              <el-option label="网络与信息安全软件服务" value="314"></el-option>
              <el-option label="网络与信息安全软件开发" value="315"></el-option>
              <el-option label="信息技术咨询服务" value="316"></el-option>
              <el-option label="区块链相关" value="317"></el-option>
              <el-option label="量子通信" value="318"></el-option>
              <el-option label="其他" value="319"></el-option>
            </el-option-group>
            <el-option-group label="互联网与云计算、大数据服务">
              <el-option label="互联网制造服务平台" value="320"></el-option>
              <el-option label="大数据服务" value="321"></el-option>
              <el-option label="互联网信息服务" value="322"></el-option>
              <el-option label="互联网平台" value="323"></el-option>
            </el-option-group>
            <el-option-group label="人工智能">
              <el-option label="信息系统集成服务" value="324"></el-option>
              <el-option label="智能终端设备制造" value="325"></el-option>
              <el-option label="人工智能应用软件开发" value="326"></el-option>
              <el-option label="脑部疾病等相关人工智能" value="327"></el-option>
              <el-option label="其他" value="328"></el-option>
            </el-option-group>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-input
            placeholder="请输入申请号"
            v-model="queryParams.appno"
            clearable
            @clear="getDataList"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getDataList"
            ></el-button>
          </el-input>
        </el-col>
        <el-col :span="16">
        </el-col>
      </el-row>


      <!-- 表格数据 -->
      <el-table :data="patentInfoList" border stripe>
        <el-table-column type="index"></el-table-column>
        <el-table-column label="语言类型" prop="ptLang" width="80px">
          <template slot-scope="scope">
            <span v-if="scope.row.ptLang == 0">中文</span>
            <span v-else>外文</span>
          </template>
        </el-table-column>
        <el-table-column label="专利类型" prop="patType" width="120px">
          <template slot-scope="scope">
            <span v-if="scope.row.patType == 1">发明专利</span>
            <span v-else-if="scope.row.patType == 2">实用新型</span>
            <span v-else>外观设计</span>
          </template>
        </el-table-column>
        <el-table-column label="申请号" prop="appNumber" width="160px"></el-table-column>
        <el-table-column label="公开号" prop="pubNumber" width="160px"></el-table-column>
        <el-table-column label="标题" prop="title"></el-table-column>
        <el-table-column label="创建时间" prop="createTime" width="160px"></el-table-column>
        <el-table-column label="操作" width="120px">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="详情"
              placement="top"
              :enterable="false"
            >
              <el-button
                type="primary"
                icon="el-icon-warning-outline"
                size="mini"
                @click="getPatentDetail(scope.row.id)"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="删除"
              placement="top"
              :enterable="false"
            >
              <el-button
                type="danger"
                icon="el-icon-delete"
                size="mini"
                @click="removeById(scope.row.id)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>


      <!-- 分页组件 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParams.pageNo"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="queryParams.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 专利详情页面 -->
    <el-dialog :title="'专利详情：' + showDetailTitle" :visible.sync="showPatentDetailDialog" v-if="showPatentDetailDialog"
      width="900px">
      <v-pt-detail :data="currentDetailPatent"></v-pt-detail>
    </el-dialog>
  </div>
</template>

<script>
import vPtDetail from '../../search/PtDetail.vue'
export default {
  components: {
    vPtDetail
  },
  data() {
    return {
      showPatentDetailDialog: false,
      queryParams: {
        ptClass: "",
        appno: "",
        pageNo: 1,
        pageSize: 10,
        mtype: 30
      },
      total: 0,
      patentInfoList: [],
      currentDetailPatent: {},
      showDetailTitle: '',
    }
  },
  created() {
    
  },
  methods: {
    handleSizeChange(newSize) {
      this.queryParams.pageSize = newSize;
      this.getDataList();
    },
    handleCurrentChange(newPage) {
      this.queryParams.pageNo = newPage;
      this.getDataList();
    },
    async getDataList() {
      const { data: res } = await this.$http.get("patent/find/inpage", {
        params: this.queryParams
      });
      if (res.code == 0) {
        this.patentInfoList = res.data.list;
        this.total = res.data.total;
      } else {
        this.$message.error(res.msg);
      }
    },
    async removeById(id) {
      const confirmResult = await this.$confirm("是否确认删除该记录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch((err) => err);
      if (confirmResult !== "confirm") {
        return this.$message.info("已取消删除");
      }
      const { data: res } = await this.$http.delete("patent/remove/"+ 30 +"/" + id);
      if (res.code == 0) {
        this.$message.success("删除成功！");
        this.getDataList();
      } else {
        return this.$message.error("删除失败！");
      }
    },
    async getPatentDetail(id) {
      const { data: res } = await this.$http.get("patent/find/detail/"+ 30 +"/" + id);
      if (res.code == 0) {
        this.showDetailTitle = res.data.ptName;
        this.currentDetailPatent = {
          lg: 1,
          baseInfo: res.data,
          detail: res.data,
          mgr: true
        };
        this.showPatentDetailDialog = true;
      } else {
        this.$message.error(res.msg);
      }
    },
  }
}
</script>

<style lang="less" scoped>

</style>